/*
 * anaar & co. — products per row
 *
 * Lets a shopper choose 3 or 4 tiles across on collection pages. The choice is
 * written to the document element, not to the grid, for two reasons: the section
 * rendering API replaces the whole of #ProductGridContainer (and the facets bar
 * with it) whenever the shopper sorts, so state kept on the grid would be thrown
 * away on the next sort; and the section's inline script can set the attribute
 * during parse, before the grid paints, which a module running after load cannot.
 *
 * Widths come from anaar-brand.css keyed on that attribute, so nothing here
 * measures or sets a pixel value.
 */

const STORAGE_KEY = 'anaar:grid-density';
const ALLOWED = ['3', '4'];

class AnaarGridDensity extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this);
    // Re-entry point after a sort re-renders the bar: the element is new but the
    // document attribute survived, so read the current state rather than assume.
    this.render();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this);
  }

  handleEvent(event) {
    const button = event.target.closest('[data-columns]');
    if (!button || !this.contains(button)) return;

    const columns = button.dataset.columns;
    if (!ALLOWED.includes(columns)) return;

    document.documentElement.setAttribute('data-anaar-density', columns);

    try {
      localStorage.setItem(STORAGE_KEY, columns);
    } catch (error) {
      // Private windows and blocked site data throw on write. The choice still
      // applies to this page; it just will not be remembered.
    }

    this.render();
  }

  render() {
    const current = document.documentElement.getAttribute('data-anaar-density');

    this.querySelectorAll('[data-columns]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.columns === current));
    });
  }
}

if (!customElements.get('anaar-grid-density')) {
  customElements.define('anaar-grid-density', AnaarGridDensity);
}
